module.exports = __webpack_public_path__ + "static/the-brothers-karamazov-b870a07e411f113b196369e94771d468.jpg";